import { LuSearch, LuX } from "react-icons/lu";
import {
  useProjectsListActions,
  useProjectsListSearchQuery,
} from "../../../core_stores/useProjectsListStore";

export default function SideMenuSearchField() {
  const searchQuery = useProjectsListSearchQuery();
  const { onSearchQueryChange } = useProjectsListActions();

  const handleClear = () => {
    onSearchQueryChange("");
  };

  return (
    <div className="relative">
      <input
        type="text"
        placeholder="Search projects..."
        value={searchQuery}
        className="w-full bg-light-surface-secondary dark:bg-dark-surface-secondary
          text-light-text dark:text-dark-text
          placeholder-light-placeholder dark:placeholder-dark-placeholder
          rounded-full py-2 pl-10 pr-10 text-sm
          border border-light-border dark:border-dark-border
          focus:outline-none focus:border-primary-blue transition-colors"
        onChange={(e) => onSearchQueryChange(e.target.value)}
      />
      <LuSearch
        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-light-text-muted dark:text-dark-text-muted"
        size={20}
      />
      {searchQuery && (
        <button
          onClick={handleClear}
          className="absolute right-3 top-1/2 transform -translate-y-1/2
            text-light-text-muted dark:text-dark-text-muted hover:text-light-text dark:hover:text-dark-text
            transition-colors duration-200"
        >
          <LuX size={16} />
        </button>
      )}
    </div>
  );
}
